import { useEffect, useState, type CSSProperties } from 'react'
import { backgroundImageUrl, loadBackgroundPhoto, type BackgroundPhoto } from '../api/backgrounds'
import { useI18n } from '../i18n'

export function AuthBackground() {
  const [photo, setPhoto] = useState<BackgroundPhoto | null>(null)
  const { t } = useI18n()

  useEffect(() => {
    let active = true
    void loadBackgroundPhoto().then(loaded => {
      if (active) setPhoto(loaded)
    })
    return () => { active = false }
  }, [])

  const style = photo ? { '--auth-background-image': `url("${backgroundImageUrl(photo.id)}")` } as CSSProperties : undefined
  return <>
    <div className="auth-backdrop" aria-hidden="true" style={style} />
    <div className="auth-photo-credit">
      {photo && <a href={`https://www.togaphotos.com/photo/${photo.id}`} target="_blank" rel="noopener noreferrer">
        {photo.photographer && <>
          <span>{t('Photo by {photographer}', { photographer: photo.photographer })}</span>
          <span aria-hidden="true"> · </span>
        </>}
        <span>{t('View photo')}</span>
      </a>}
    </div>
  </>
}
